// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// ForgeStudio — Multi-Engine Game Builder
// ================================================================
import React, { Suspense, lazy, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header, { getActiveEngine } from './components/Header';
import Footer from './components/Footer';
import './App.css';

const HomePage = lazy(() => import('./pages/HomePage'));
const BuilderPage = lazy(() => import('./pages/BuilderPage'));
const PreviewPage = lazy(() => import('./pages/PreviewPage'));
const GuidePage = lazy(() => import('./pages/GuidePage'));
const PricingPage = lazy(() => import('./pages/PricingPage'));

function AppLoading() {
  return (
    <div className="app-loading-screen">
      <div className="app-loading-spinner" />
      <span>Loading ForgeStudio...</span>
    </div>
  );
}

export default function App() {
  const [engine, setEngine] = useState(getActiveEngine());

  return (
    <div className="app-root">
      <Header engine={engine} onEngineChange={setEngine} />
      <main className="app-main">
        <Suspense fallback={<AppLoading />}>
          <Routes>
            <Route path="/" element={<HomePage engine={engine} />} />
            <Route path="/build/:archetypeId" element={<BuilderPage engine={engine} />} />
            <Route path="/preview" element={<PreviewPage engine={engine} />} />
            <Route path="/guide" element={<GuidePage engine={engine} />} />
            <Route path="/pricing" element={<PricingPage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
